import './Header.scss'
import ThemeButton from './ThemeButton'
import { useContext } from 'react'
import { ThemeContext } from '../../context'
import { NavLink } from 'react-router-dom'

export default function Header()
{
    const {theme} = useContext(ThemeContext)
    return(
        <header id={`header_${theme}`} className="header">
            <div id="header_logo">En Attendant Le Degel</div>
            <div className={`header_nav_${theme} , nav`}>
                <NavLink to="/">- Accueil -</NavLink>
                <NavLink to="/about">- A propos -</NavLink>
            </div>
            <div id="header_button">
                <ThemeButton/>
            </div>
        </header>
    )
}